import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

export const uploadFileAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.post(`${apiBaseUrl}/bulk-leads`, formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error adding excel file:", error);
    throw error;
  }
};


export const CustuploadFileAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.post(`${apiBaseUrl}/bulk-customers`, formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error adding excel file:", error);
    throw error;
  }
};



export const PolicyuploadFileAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.post(`${apiBaseUrl}/bulk-policies`, formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error adding excel file:", error);
    throw error;
  }
};


export const getLeadsBulkUploadsAPI = async () => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.get(`${apiBaseUrl}/leads-bulk-uploads`, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error getting bulk leads:", error);
    throw error;
  }
};



export const getCustBulkUploadsAPI = async () => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.get(`${apiBaseUrl}/customers-bulk-uploads`, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error getting bulk Customer:", error);
    throw error;
  }
};


export const getPolicyBulkUploadsAPI = async () => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.get(`${apiBaseUrl}/policies-bulk-uploads`, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error getting bulk Policies:", error);
    throw error;
  }
};

export const revertBulkUploadAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.post(`${apiBaseUrl}/revert-bulk-upload`, formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error Revert excel file:", error);
    throw error;
  }
};

export const getLifeBulkPoliciesAPI = async () => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.get(`${apiBaseUrl}/life-policies-bulk-uploads`, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error getting bulk Life Policies:", error);
    throw error;
  }
};

export const mutualFundBulkuploadAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.post(`${apiBaseUrl}/bulk-mutualFund`, formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error adding excel file:", error);
    throw error;
  }
};

export const revertMutualFundBulkUploadAPI = async formdata => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.post(`${apiBaseUrl}/revert-bulkMutualFund`, formdata, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error Revert excel file:", error);
    throw error;
  }
};


export const getMutualFundBulkUploadsAPI = async () => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    const response = await axios.get(`${apiBaseUrl}/view-bulkMutualFund`, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error getting bulk leads:", error);
    throw error;
  }
};